import React, { useLayoutEffect, useEffect, useState } from 'react';
import { ErrorScreen } from 'components/common';
import { useJob } from 'components/hooks';
import withRequest from 'hoc/withRequest';
import { withRouter } from 'react-router-dom';
import { CircularProgress, Backdrop } from '@mui/material';
import JobRunTemplateDumb from './JobRunTemplateDumb';
import { API_HOST } from 'consts';


const JobRunTemplateSmart = (props) => {
  const { match: { params } } = props;
  const { jobId } = params;
  const { data, getJobRun, getNextPage, updateJobTemplate, cleanUpMessage, isLoaded, success, error ,cleanUp} = useJob();
  const [intervalUpdate, setIntervalUpdate] = useState(0);
  const [scrollToEnd, setScrollToEnd] = useState(true);

  const handleDownloadFile = (blob) => {
    
    const url = API_HOST+"/getJobLog?job_id="+blob
    const link = document.createElement('a');
    link.href = url;
    link.target = "_new"+new Date().getTime();
    link.setAttribute(
      'download',
      `log-job-${blob}.log`,
    );
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
  }

  useLayoutEffect(() => {
    getJobRun({ query: { jobId } });
    cleanUp();

    return () => cleanUpMessage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let intervalUpdate;
    if (data && (data.status === 'WA' || data.status === 'RU')) {
      updateJobTemplate({ query: { jobId } });
      intervalUpdate = setInterval(() => {
        updateJobTemplate({ query: { jobId } });
      }, 4000);
      setIntervalUpdate(intervalUpdate);
    }
    return () => clearInterval(intervalUpdate);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success.get]);

  useEffect(() => {
    console.log(".------>",data);
    if (data && ['WA','RU'].indexOf(data.status) == -1){
      intervalUpdate && clearInterval(intervalUpdate);
    }
  }, [data,intervalUpdate]);

  return (
    <>
      { (error.get || error.updateJob)?
        (
          <ErrorScreen />
        ): isLoaded.get ?
        (
          <Backdrop
            invisible
            sx={{ zIndex: (theme) => theme.zIndex.drawer - 1 }}
            open={true}
          >
            <CircularProgress color="primary" />
          </Backdrop>
        ): (data) &&
        (
          <JobRunTemplateDumb
            data={data}
            handleDownloadFile={handleDownloadFile}
            fetchGetNextPage={()=>{
                getNextPage({ query: { jobId }});
                //setPage(page+1);
              }
            }
            haveToScrollToEnd={scrollToEnd} 
            setScrollToEnd={setScrollToEnd}
          />
        )
      }
    </>
  );
};

export default withRequest(withRouter(JobRunTemplateSmart));
